import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { api, mediaUrl } from "@/lib/api";
import { renderRich } from "@/lib/rich";
import { ArrowRight } from "lucide-react";

export default function About() {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    api.get("/about").then((res) => setAbout(res.data)).catch(() => {});
  }, []);

  const paragraphs = (about?.body || "").split(/\n{2,}/).filter(Boolean);

  return (
    <div className="relative z-10">
      <Header />
      <section className="max-w-5xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-10 grid md:grid-cols-2 gap-12 md:gap-16 items-center">
        <div className="overflow-hidden">
          {about?.image ? (
            <img
              src={mediaUrl(about.image)}
              alt={about?.name || "Ritratto"}
              className="w-full aspect-[4/5] object-cover"
              data-testid="about-portrait"
            />
          ) : (
            <div className="w-full aspect-[4/5] bg-[#E7E5E4]" />
          )}
        </div>
        <div>
          <p className="label-ui text-[#9F583F] mb-5">Chi sono</p>
          <h1 className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight text-[#1C1917]">
            {about?.name || "Fabio Campana"}
          </h1>
          <div className="font-body text-lg text-[#57534E] mt-8 leading-relaxed space-y-5" data-testid="about-body">
            {paragraphs.map((p, i) => (
              <p key={i}>{renderRich(p)}</p>
            ))}
          </div>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-10 label-ui text-[#1C1917] hover:text-[#9F583F] transition-colors"
          >
            Leggi gli articoli <ArrowRight size={15} strokeWidth={1.5} />
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
